import { render, staticRenderFns } from "./enter-ar-button.component.vue?vue&type=template&id=518d5bb3&"
import script from "./enter-ar-button.component.vue?vue&type=script&lang=js&"
export * from "./enter-ar-button.component.vue?vue&type=script&lang=js&"
import style0 from "./enter-ar-button.component.vue?vue&type=style&index=0&id=518d5bb3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports